import { PageLinks } from '../components/PageLinks';
import { Story } from '../sections/Story';

/**
 * Us. No page head of its own: the story's section head already names the
 * page, and a title above it would only say the same thing twice.
 */
export function OurStory() {
  return (
    <main class="page" id="top">
      <Story />
      <PageLinks />
    </main>
  );
}
